module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.y === 'top',
      "bottom": _vm.y === 'bottom',
      "right": _vm.x === 'right',
      "left": _vm.x === 'left',
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarText) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-alert', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "outline": "",
      "color": "info",
      "icon": "check_circle",
      "dismissible": ""
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.alertText) + "\n  ")]), _vm._v(" "), (_vm.associatedGenesData.length) ? _c('v-alert', {
    staticStyle: {
      "width": "90%",
      "border-style": "none",
      "border-color": "white !important",
      "border": "0px !important"
    },
    attrs: {
      "dismissible": "",
      "color": "blue darken-1",
      "outline": ""
    },
    model: {
      value: (_vm.alertAssociatedInfo),
      callback: function($$v) {
        _vm.alertAssociatedInfo = $$v
      },
      expression: "alertAssociatedInfo"
    }
  }, [_vm._v("\n      Genes marked with the "), _c('v-icon', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("verified_user")]), _vm._v(" icon are reported to be associated with the condition; it is possible that they do not appear on any panels that test for the condition. These genes will always appear at the top of the gene list.\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "id": "genes-table",
      "headers": _vm.headers,
      "items": _vm.items,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "name",
      "search": _vm.search,
      "custom-filter": _vm.filterItemsOnSearch,
      "no-data-text": "No Genes Available Currently"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_c('th', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.all,
            "indeterminate": props.indeterminate
          },
          nativeOn: {
            "click": function($event) {
              return _vm.toggleAll($event)
            }
          }
        })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : '', header.visibility, header.class, header.width]
          }, [(header.text === 'Gene Panels') ? _c('span', [_c('v-layout', {
            staticStyle: {
              "margin-left": "-20px"
            }
          }, [_c('v-flex', {
            staticStyle: {
              "margin-top": "40px",
              "padding-left": "20px"
            },
            attrs: {
              "xs1": ""
            }
          }, [_c('small', [_vm._v(_vm._s(_vm.minSliderValue))])]), _vm._v(" "), _c('v-flex', {
            staticStyle: {
              "padding-top": "12px"
            },
            attrs: {
              "xs10": ""
            }
          }, [_c('div', [(_vm.sliderValue >= 0) ? _c('v-slider', {
            attrs: {
              "track-color": _vm.color,
              "thumb-label": "always",
              "color": _vm.sliderColor,
              "thumb-color": _vm.color,
              "thumb-size": 20,
              "max": _vm.maxSliderValue,
              "min": _vm.minSliderValue
            },
            on: {
              "change": _vm.sliderClicked
            },
            model: {
              value: (_vm.sliderValue),
              callback: function($$v) {
                _vm.sliderValue = $$v
              },
              expression: "sliderValue"
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('div', {
            staticStyle: {
              "margin-top": "-20px",
              "padding-bottom": "10px"
            }
          }, [_c('center', [_vm._v(_vm._s(header.text))])], 1)]), _vm._v(" "), _c('v-flex', {
            staticStyle: {
              "margin-top": "40px"
            },
            attrs: {
              "xs1": ""
            }
          }, [_c('small', [_vm._v(_vm._s(_vm.maxSliderValue))])])], 1)], 1) : (header.text === 'Gene Name') ? _c('span', [_c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (!_vm.openSearchBox),
              expression: "!openSearchBox"
            }]
          }, [_vm._v("\n               " + _vm._s(header.text) + "     "), _c('v-icon', {
            staticStyle: {
              "opacity": "2",
              "color": "#222",
              "cursor": "pointer"
            },
            attrs: {
              "right": ""
            },
            on: {
              "click": function($event) {
                _vm.openSearchBox = true
              }
            }
          }, [_vm._v("search")])], 1), _vm._v(" "), _c('div', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.openSearchBox),
              expression: "openSearchBox"
            }]
          }, [_c('v-layout', [_c('v-flex', {
            staticStyle: {
              "margin-top": "-30px"
            },
            attrs: {
              "xs8": ""
            }
          }, [_c('div', {
            attrs: {
              "id": "geneSearchBox"
            }
          }, [_c('v-text-field', {
            attrs: {
              "label": "Search for Gene",
              "prepend-icon": "search",
              "single-line": "",
              "hide-details": ""
            },
            model: {
              value: (_vm.search),
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })], 1)]), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs1": ""
            }
          }, [_c('v-icon', {
            staticStyle: {
              "opacity": "2",
              "color": "#222",
              "cursor": "pointer"
            },
            on: {
              "click": function($event) {
                _vm.openSearchBox = false
              }
            }
          }, [_vm._v("close")])], 1)], 1)], 1)]) : _c('span', [_vm._v(_vm._s(header.text))])])
        })], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.indexVal))]), _vm._v(" "), _c('td', [_c('div', {
          attrs: {
            "id": "app"
          }
        }, [_c('div', [_c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "600",
            "margin-top": "2px"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n                  " + _vm._s(props.item.name) + "\n                ")]), _vm._v(" "), (props.item.isAssociatedGene === true) ? _c('span', [_c('v-icon', {
          staticStyle: {
            "font-size": "20px"
          },
          attrs: {
            "color": "blue darken-2"
          }
        }, [_vm._v("verified_user")])], 1) : _vm._e()])])]), _vm._v(" "), (_vm.multipleSearchDisorders.length > 1) ? _c('td', _vm._l((props.item.searchTermIndexSVG), function(x) {
          return _c('span', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(x)
            }
          })])
        })) : _vm._e(), _vm._v(" "), _c('td', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(props.item.htmlData)
          }
        })]), _vm._v(" "), _c('td', [_c('v-menu', {
          staticStyle: {
            "color": "black"
          },
          attrs: {
            "bottom": "",
            "offset-y": ""
          }
        }, [_c('v-icon', {
          staticStyle: {
            "padding-right": "4px"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("more_vert")]), _vm._v(" "), _c('v-card', [_c('div', {
          staticClass: "conditionsBox"
        }, [_c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', {
          staticStyle: {
            "font-size": "18px"
          }
        }, [_vm._v(" Gene Resource Links  "), _c('i', [_vm._v("( " + _vm._s(props.item.name) + " )")])])])], 1)], 1), _vm._v(" "), _c('v-divider', {
          staticClass: "Rightbar_card_divider"
        }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("MedGen")]), _c('a', {
          attrs: {
            "href": props.item.medGenSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                          MedGen organizes information related to human medical genetics, such as attributes of conditions with a genetic contribution.\n                      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("OMIM")]), _c('a', {
          attrs: {
            "href": props.item.omimSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                        OMIM is a comprehensive, authoritative compendium of human genes and genetic phenotypes\n                      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("GeneCards")]), _c('a', {
          attrs: {
            "href": props.item.geneCardsSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                        GeneCards is a searchable, integrative database that provides comprehensive, user-friendly information on all annotated and predicted human genes.\n                      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("Genetics Home Reference")]), _c('a', {
          attrs: {
            "href": props.item.ghrSrc,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                        Genetics Home Reference provides consumer-friendly information about the effects of genetic variation on human health.\n                      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("ClinGen")]), _c('a', {
          attrs: {
            "href": props.item.clinGenLink,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                        The Clinical Genome Resource (ClinGen) consortium curates genes and regions of the genome to assess whether there is evidence to support that these genes/regions are dosage sensitive and should be targeted on a cytogenomic array                       ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v("Gene ID "), _c('i', [_vm._v(" ( " + _vm._s(props.item.geneid) + " )")])]), _c('a', {
          attrs: {
            "href": props.item.geneIdLink,
            "target": "_blank"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "round": "",
            "outline": "",
            "color": "primary"
          }
        }, [_vm._v("Link")])], 1)]), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('br')], 1)], 1)])], 1)], 1)])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gene-bar-chart-box"
    }
  }, [_c('div', {
    attrs: {
      "id": "gene-bar-chart"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce40bfbc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/ShowGenePanel.vue
// module id = 519
// module chunks = 0